import Badge from '@/components/badges/Badge'
import DualIcon from '@/components/tokens/DualIcon'
import { useGetNetworkIcon, useGetWalletIcon } from '@/components/tokens/WalletIcon'
import { Text } from '@/components/ui/text'
import { useNativeToken } from '@/context'
import { useTokenBalance } from '@/hooks'
import { formatTokenAmount, getBtcWalletAddressTypeLabel, truncateAddress } from '@/utils'
import { WalletContextType } from '@/wallets'

interface WalletBtcItemProps {
  wallet: WalletContextType
  address: string
  onClick: () => void
}

const WalletBtcItem: React.FC<WalletBtcItemProps> = ({ wallet, address, onClick }) => {
  const token = useNativeToken(wallet?.network)
  const { data: balance } = useTokenBalance({ token, walletAddress: address })
  const getWalletIcon = useGetWalletIcon()
  const getNetworkLogo = useGetNetworkIcon()
  return (
    <div
      className='flex items-center flex-1 justify-between py-3 last:pb-0 cursor-pointer duration-300 transition-all hover:bg-dark-4 px-4'
      onClick={onClick}
      aria-label='Select BTC address'
    >
      <div className='flex items-center md:gap-x-1 gap-x-2 flex-1'>
        <DualIcon
          primaryClassName='size-7 md:size-10 rounded-md'
          secondaryClassName='size-3 md:size-4 border border-[1.5px] border-black-100 rounded outline-dark-3 -right-1.5 -bottom-px'
          primaryIcon={getNetworkLogo(wallet.networkInfo?.networkId) || ''}
          secondaryIcon={getWalletIcon(wallet.wallet)}
        />
        <div className='flex flex-col flex-1'>
          <Text>
            {formatTokenAmount(balance || '0', token?.tokenSymbol || '')} {wallet.networkInfo?.networkSymbol || ''}
          </Text>
          <div className='flex items-center gap-1.5 justify-between'>
            <Text color='white-48'>{truncateAddress(address || '')}</Text>
          </div>
        </div>
      </div>
      <Badge className='rounded-sm text-size-12 px-4 py-2 bg-white-4' text={getBtcWalletAddressTypeLabel(address)} />
    </div>
  )
}

export default WalletBtcItem
